module.exports = __webpack_public_path__ + "static/media/group.6aa5dafc.svg";